import React, { Component } from 'react';
import TextInput from '../../../../../../components/ZUILib/TextInput';
import InputButton from '../../../../../../components/ZUILib/InputButton'; 
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
class PersonalDataWap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Initialize your state here if needed
        };
    }

    actualizarDatos = {
        id: 'updateData',
        type: 'button',
        name: 'Actualizar datos',
        value: 'Actualizar datos',
        classname: 'btn btn-default',
        onClickHandler: () => {
            // Handle clear filter action
            console.log('update personal data clicked');
        },
        disabled: false,
        autoFocus: false,
        ariaLabel: 'update personal data',
        ariaHidden: false,
        cssStyle: {
            width: '100%',
            padding: '16px',
            backgroundColor: '#D8D8D8',
            borderRadius: '4px'
        },
    };

    render() {

        return (
            <div className="personal-data-wrapper row" style={{
                 backgroundColor: '#f9f9f9',

            }}>
                <div className='personal-data-title'
                    style={{
                        fontSize: '20px',
                        color: '#333',
                        fontWeight: '600',
                        padding: '0 16px',
                        textAlign: 'center',
                        marginBottom: '24px',
                    }}
                >Verifica tus datos</div>
                <div>
                    <div className="personal-data-container col-md-6 col-sm-12 col-xs-12"
                        style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column',
                            gap: '16px', 
                            padding: '16px'
                        }}
                    >   

                        {/* //   Festejado section starts here */}
                        <div className='personal-data-celebrated-section' style={{
                            padding: '16px',
                            backgroundColor: '#ffffff',
                            flex: 1,
                        }}> 
                            <div style={{
                                fontSize: '14px', fontWeight: "600",
                                marginBottom: '24px'
                            }}>
                                Festejado                                 
                            </div>
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="name"
                                label="Nombre"
                                name="Nombre"
                                required="true"
                                star="*"
                                onChange={() => { }} />


                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="firstSurname"
                                label="Primer apellido"
                                name="Primer apellido"
                                required="true"
                                star="*"
                                onChange={() => { }}
                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="lastname"
                                label="Segundo apellido"
                                name="Segundo apellido"
                                required="true"
                                star="*"
                                onChange={() => { }}

                            />
                            <div style={{
                                fontSize: '14px',
                                fontWeight: "400",
                                marginLeft: '20px',
                            }}>
                                <CheckBox 
                                htmlId={'showEmail1'} 
                                displayName={"Invitar a administrar la mesa de regalos"} 
                                />
                            </div> 
                            
                        </div>

                        {/* //   Festejado section ends here */}

                        <div className='personal-data-your-section' style={{
                            padding: '16px',
                            backgroundColor: '#ffffff',
                            flex: 1,
                        }}>
                            <div style={{
                                fontSize: '10px',
                                fontWeight: "400",
                                marginBottom: '8px',
                                color: "#F00",
                                textAlign: 'right'
                            }}>
                                *Campos obligatorios
                            </div>

                            <div style={{
                                fontSize: '14px', fontWeight: "600",
                                marginBottom: '24px'
                            }}>
                                Tus datos
                                <span>(Administrador)</span>
                            </div>
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="name"
                                label="Nombre"
                                name="Nombre"
                                required="true"
                                star="*"
                                onChange={() => { }} />


                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="firstSurname"
                                label="Primer apellido"
                                name="Primer apellido"
                                required="true"
                                star="*"
                                onChange={() => { }}
                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="lastname"
                                label="Segundo apellido"
                                name="Segundo apellido"
                                required="true"
                                star="*"
                                onChange={() => { }}

                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="phone"
                                label="Celular"
                                required="true"
                                star="*"
                                maxlength="10"
                                value={''}
                                onKeyPress={(e) => { }}
                                onPaste={(e) => { }}
                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="email"
                                label="Correo electrónico"
                                required="false"
                                maxlength="100"
                                onChange={(e) => { }}
                                name="email"
                                parentClassName={''}
                                disabled={false}
                                value={''}
                            />
                        </div>
                        {/* Add your component content here */}
                    </div>
                    <div className="personal-data-container col-md-6 col-sm-12 col-xs-12"
                        style={{ display: 'flex' }}
                    >
                        <div className='personal-data-partner-section' style={{
                            padding: '16px',
                            backgroundColor: '#ffffff',
                            flex: 1,
                            padding: '16px'
                        }}>
                            <div style={{
                                fontSize: '14px', fontWeight: "600",
                                marginBottom: '24px'
                            }}>
                                Datos de tu pareja
                            </div>
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="partnerName"
                                label="Nombre(s) de tu pareja"
                                name="partnerName"
                                required="true"
                                star="*"
                                onChange={() => { }} />


                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="partnerFirstSurname"
                                label="Primer apellido"
                                name="Primer apellido"
                                required="true"
                                star="*"
                                onChange={() => { }}
                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="partnerSecondSurname"
                                label="Segundo apellido"
                                name="Segundo apellido"
                                required="true"
                                star="*"
                                onChange={() => { }}

                            /> 
                            <div style={{
                                fontSize: '14px',
                                fontWeight: "400",
                                marginLeft:'20px'
                            }}>
                                <CheckBox 
                                 htmlId= {'showEmail2'}
                                 name= 'check'
                                 displayName={"Invitar a administrar la mesa de regalos"}  />
                            </div>    

                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="phone"
                                label="Celular"
                                required="true"
                                star="*"
                                maxlength="10"
                                value={''}
                                onKeyPress={(e) => { }}
                                onPaste={(e) => { }}
                            />
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="email"
                                label="Correo electrónico"
                                required="false"
                                maxlength="100"
                                onChange={(e) => { }}
                                name="email"
                                parentClassName={''}
                                disabled={false}
                                value={''}
                            />                         
                        </div>
                        {/* Add your component content here */}
                    </div>
                </div>
                <div className='col-md-12 col-sm-12 col-xs-12'
                
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    position:"sticky",
                    bottom: '0',
                    backgroundColor:"#F5F5F5",
                    padding: '16px',
                    gap: '16px',
                }}>
                    <div className="personal-data-button" style={{
                        width: '50%',
                        
                    }}>
                        {/* <InputButton buttonAttr={this.actualizarDatos}
                         /> */}
                        <button
                            type='button'
                            style={{
                                width: '100%',
                                padding: '16px',
                                backgroundColor: '#FFF',
                                borderRadius: '4px',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#333',
                                fontSize: '16px', 
                                border: '1px solid #333'
                            }}
                        >
                            Regresar
                        </button>
                    </div>
                    <div className="personal-data-button" style={{
                        width: '50%',
                    }}>
                        {/* <InputButton buttonAttr={this.actualizarDatos}
                         /> */}
                        <button
                            type='button'
                            style={{
                                width: '100%',
                                padding: '16px',
                                backgroundColor: '#D8D8D8',
                                borderRadius: '4px',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#fff',
                                fontSize: '16px', 
                            }}
                        >
                            Actualizar datos
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}

export default PersonalDataWap;